<template>
  <v-btn
    :color="color"
    :flat="flat"
    :fab="fab"
    :small="small"
    :block="block"
    :icon="icon"
    :dark="dark && !(pasif || disabled)"
    :disabled="pasif || disabled"
    @click="tikla"
  >
    <slot>{{ $t("save_button") }}</slot>
  </v-btn>
</template>

<script>
/**
 * Cift tiklamaya karsi korumali kaydet butonu.
 *
 * Davranis:
 *   - tiklaninca HEMEN pasiflesir,
 *   - istek bitene kadar pasif kalir,
 *   - cevap geldikten SONRA da `bekleme` ms boyunca pasif kalmaya devam eder
 *     (kullanici cevabi gorsun, refleksle ikinci kez basmasin),
 *   - istek HATA verse bile kilit acilir; sonsuza dek pasif kalmaz.
 *
 * Istek disaridan `action` prop'uyla verilir ve Promise dondurmelidir.
 * Bileseni API katmanina baglamamak bilincli: hem yeniden kullanilabilir
 * kalir hem de testte cozulme ani kontrol edilebilir.
 *
 * Cift tik korumasi yalnizca `disabled` ile YAPILMAZ. Hizli cift tikta
 * tarayici ikinci olayi, disabled DOM'a yansimadan once gecirebiliyor;
 * asil koruma handler'in basindaki _calisiyor bayragidir.
 */
export default {
  name: "kaydetbutonu",

  props: {
    /** Promise donduren islem. Zorunlu. */
    action: { type: Function, required: true },

    /** Cevaptan sonra pasif kalinacak sure (ms). */
    bekleme: { type: Number, default: 2000 },

    /** Disaridan pasiflestirme (orn. form gecersiz). */
    disabled: { type: Boolean, default: false },

    color: { type: String, default: "primary" },
    flat: { type: Boolean, default: true },

    // v-btn'e gecirilen gorunum bayraklari; buton metin, fab veya satir ici
    // ikon butonu olarak kullanilabilsin diye.
    fab: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
  },

  data() {
    return { pasif: false };
  },

  methods: {
    tikla() {
      // Asil cift tik korumasi burasi.
      if (this._calisiyor) return;
      this._calisiyor = true;
      this.pasif = true;

      let sonuc;
      try {
        sonuc = this.action();
      } catch (e) {
        // action senkron patlarsa da kilidi acmak gerekir.
        this.bitir();
        this.$emit("hata", e);
        return;
      }

      Promise.resolve(sonuc).then(
        (cevap) => {
          this.$emit("tamam", cevap);
          this.bitir();
        },
        (hata) => {
          this.$emit("hata", hata);
          this.bitir();
        }
      );
    },

    /** Cevaptan sonra beklemeyi baslatir ve sonunda kilidi acar. */
    bitir() {
      this._zamanlayici = setTimeout(() => {
        this._zamanlayici = null;
        this._calisiyor = false;
        this.pasif = false;
      }, this.bekleme);
    },
  },

  beforeDestroy() {
    // Bilesen bekleme dolmadan yok edilirse (dialog kapatilinca olur)
    // zamanlayici yok edilmis ornege dokunmamali.
    if (this._zamanlayici) clearTimeout(this._zamanlayici);
  },
};
</script>
